import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import { quicktype, InputData, jsonInputForTargetLanguage } from 'quicktype-core';

export const TypeGeneratorView: React.FC = () => {
  const [json, setJson] = useState<string>('{\n  "name": "MamaJSON",\n  "awesome": true\n}');
  const [output, setOutput] = useState<string>('');
  const [lang, setLang] = useState<string>('typescript');

  useEffect(() => {
    const generate = async () => {
      try {
        const jsonInput = jsonInputForTargetLanguage(lang as Parameters<typeof jsonInputForTargetLanguage>[0]);
        await jsonInput.addSource({ name: 'Root', samples: [json] });
        const inputData = new InputData();
        inputData.addInput(jsonInput);
        
        const result = await quicktype({
          inputData,
          lang: lang as Parameters<typeof jsonInputForTargetLanguage>[0]
        });
        setOutput(result.lines.join('\n'));
      } catch (err: unknown) {
        if (err instanceof Error) {
          setOutput(`// Error generating types:\n// ${err.message}`);
        } else {
          setOutput(`// Error generating types:\n// ${String(err)}`);
        }
      }
    };
    void generate();
  }, [json, lang]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Type Generator</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Instantly generate interfaces and structs from JSON.</p>
        </div>
        <select 
          value={lang} 
          onChange={(e) => { setLang(e.target.value); }}
          style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid var(--color-border)', background: 'var(--color-bg-secondary)', color: 'var(--color-text-primary)' }}
        >
          <option value="typescript">TypeScript</option>
          <option value="go">Go</option>
          <option value="rust">Rust</option>
          <option value="swift">Swift</option>
          <option value="python">Python</option>
          <option value="kotlin">Kotlin</option>
        </select>
      </div>
      
      <div style={{ display: 'flex', gap: '1rem', flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <div style={{ flex: 1, minHeight: 0, position: 'relative', border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Editor
            height="100%"
            defaultLanguage="json"
            value={json}
            onChange={(value) => { setJson(value ?? ''); }}
            theme="vs-dark"
            options={{ minimap: { enabled: false }, padding: { top: 16 } }}
          />
        </div>
        </div>
        <div style={{ flex: 1, minHeight: 0, position: 'relative', border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Editor
            height="100%"
            language={lang === 'rust' ? 'rust' : lang === 'go' ? 'go' : lang === 'swift' ? 'swift' : lang === 'python' ? 'python' : 'typescript'}
            value={output}
            theme="vs-dark"
            options={{ minimap: { enabled: false }, readOnly: true, padding: { top: 16 } }}
          />
        </div>
        </div>
      </div>
    </div>
  );
};
